export const GENDER_ITEMS = ['Male', 'Female'];
